import React from 'react';
import type { FormInstance } from 'antd';
import { Form } from 'antd';
import AlignLeftOutlined from '@ant-design/icons/AlignLeftOutlined';
import AlignCenterOutlined from '@ant-design/icons/AlignCenterOutlined';
import AlignRightOutlined from '@ant-design/icons/AlignRightOutlined';
import MenuOutlined from '@ant-design/icons/MenuOutlined';
import { RibbonIconButton } from '../bookDefaultStyles/WordStyleRibbon';
import { styleFieldName } from '../../utils/styleFormFieldNames';

type Props = {
  form: FormInstance;
  namePrefix?: string | string[];
};

const ALIGNMENTS = [
  { value: 'left', title: 'Align left', icon: <AlignLeftOutlined /> },
  { value: 'center', title: 'Align center', icon: <AlignCenterOutlined /> },
  { value: 'right', title: 'Align right', icon: <AlignRightOutlined /> },
  { value: 'justify', title: 'Justify', icon: <MenuOutlined /> },
] as const;

export const AlignToggleButtons: React.FC<Props> = ({ form, namePrefix }) => {
  const align = Form.useWatch(styleFieldName(namePrefix, 'align'), form) ?? 'left';

  return (
    <div className="word-ribbon-inline">
      {ALIGNMENTS.map(({ value, title, icon }) => (
        <RibbonIconButton
          key={value}
          title={title}
          active={align === value}
          onClick={() => form.setFieldValue(styleFieldName(namePrefix, 'align'), value)}
        >
          {icon}
        </RibbonIconButton>
      ))}
    </div>
  );
};
